<script>
export default {
  data() {
    return {
      showFooter: true,
      feedbackItems: [
        {
          label: 'Support',
          goTo: 'https://support.texasoncourse.org/',
        },
        { label: 'Academy', goTo: 'https://dashboard.texasoncourse.org/#/' },
        {
          label: 'Web Accessibility',
          goTo: 'https://cio.utexas.edu/policies/web-accessibility',
        },
        {
          label: 'Feedback',
          goTo: 'https://support.texasoncourse.org/',
        },
      ],
    }
  },
}
</script>

<template>
  <v-layout
    row
    class="feedback"
    justify-center>
    <v-flex xs12>
      <v-card
        height="100"
        tile>
        <v-layout
          fill-height
          justify-center
          row>
          <v-flex
            class="footer-logo"
            xs2>
            <img
              src="@src/core/assets/images/logo-footer.png"
              alt="Texas On Course Logo Footer">
          </v-flex>
          <v-flex
            v-for="(item,index) in feedbackItems"
            :key="index"
            xs2>
            <v-btn
              :href="item.goTo"
              color="white"
              target="_blank"
              flat>{{ item.label }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<style>
.feedback {
  margin: 260px 0px 0px 0px;
}
.feedback .btn {
  margin: 0px;
  height: 100%;
  width: 100%;
}
.feedback .card {
  background-color: #2f2f2f;
  align-content: center;
}
.footer-logo {
  align-self: center;
}
.footer-logo img {
  width: 242px;
  height: 64px;
}
</style>
